module.exports = __webpack_public_path__ + "assets/img/01a238497fa91f16cba8150159f3a25a.png";